import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Snackbar, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { queryCache, useMutation } from 'react-query';
import { useAuth } from '../../../../../auth/authProvider';
import partnershipRequest from '../../../../../services/network/partnershipRequest';

export const MarcarPagamentoJaPagoDialog = props => {
  const { show, onClose, data, refetchInvoices } = props;
  const { token } = useAuth();
  const [alert, setAlert] = useState({ show: false, msg: '' });

  const [marcarPagamentoJaPago, { isLoading }] = useMutation(
    () =>
      partnershipRequest.patch(
        `invoices/partner-invoice-comissioning-lead/${data?.paymentId}/already-paid`,
        {},
        { token },
      ),
    {
      onSuccess: () => {
        setAlert({ show: true, msg: 'Pagamento movido para a invoice de ja pago' });
        onClose();
        queryCache.refetchQueries('fetch-payments');
        queryCache.refetchQueries('fetch-payment-validations');
        if (refetchInvoices) {
          refetchInvoices();
        }
      },
      onError: error => {
        setAlert({ show: true, msg: error?.message || error || 'Erro ao marcar item como ja pago' });
      },
    },
  );

  return (
    <>
      <Dialog open={show} onClose={onClose}>
        <DialogTitle>Marcar item como ja pago?</DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            Esse pagamento sera removido da invoice atual e movido para a invoice manual de referencia 2023-01-01.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary" disabled={isLoading}>
            CANCELAR
          </Button>
          <Button color="primary" onClick={marcarPagamentoJaPago} disabled={isLoading}>
            CONFIRMAR
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={alert.show}
        autoHideDuration={6000}
        message={alert.msg}
        onClose={() => setAlert({ show: false, msg: '' })}
      />
    </>
  );
};
